/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import { reset } from 'redux-form';
import { getCustomUidAction, sendUidAction, setCustomUidAction } from './actions';
import { getIsModalShownSelector, getIsFormSendingSelector, getIsCustomUidLoadingSelector } from './selectors';
import { FORM_NAME } from './constants';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import { useInjectSaga } from '../../utils/injectSaga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import saga from './saga';
import { removeModalQuery } from '../../utils/removeModalQuery';

import closeModal from '../../utils/closeModal';
import { CustomUidForm } from './components/custom-uid-form';

const CustomUidModalWrapper = ({
	onGetCustomUid,
	isModalShown,
	onSendUid,
	onResetForm,
	isFormSending,
	onSetCustomUid,
	isCustomUidLoading,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'customUidModalSaga', saga });
	useInjectReducer({ key: 'customUidModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (isModalShown) {
			onGetCustomUid(query.get('id'));
		}
	}, [isModalShown]);

	const handleModalCancel = () => {
		query.set('modal', 'reqs_details');
		onResetForm(FORM_NAME);
		onSetCustomUid(null);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		onResetForm(FORM_NAME);
		onSetCustomUid(null);
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		onSendUid({
			redirect: handleModalCancel,
			id: query.get('id'),
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Изменить номер заявки"
			modalContent={<CustomUidForm />}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'custom_uid' }]}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Сохранить',
							color: 'success',
							loading: isFormSending,
							disabled: isFormSending || isCustomUidLoading,
						},
						{
							onClick: handleModalCancel,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isFormSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isModalShown: getIsModalShownSelector(),
	isFormSending: getIsFormSendingSelector(),
	isCustomUidLoading: getIsCustomUidLoadingSelector(),
});

const mapDispatchToProps = {
	onGetCustomUid: getCustomUidAction,
	onSendUid: sendUidAction,
	onResetForm: reset,
	onSetCustomUid: setCustomUidAction,
};

const CustomUidModal = connect(mapStateToProps, mapDispatchToProps)(CustomUidModalWrapper);

CustomUidModalWrapper.propTypes = {
	onGetCustomUid: PropTypes.func.isRequired,
	onSendUid: PropTypes.func.isRequired,
	isFormSending: PropTypes.bool.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	onResetForm: PropTypes.func.isRequired,
	onSetCustomUid: PropTypes.func.isRequired,
	isCustomUidLoading: PropTypes.bool.isRequired,
};

export default CustomUidModal;
